import { useState } from 'react'
import { inputCommon } from '../inputCommon'
import { validateFieldFormat } from '../../fieldValidators'
import type { FieldInputProps } from '../types'

const TYPE_MAP: Record<string, { type: string; inputMode?: 'tel' | 'numeric' | 'text'; placeholder?: string }> = {
  EMAIL: { type: 'email' },
  PHONE: { type: 'tel', inputMode: 'tel', placeholder: '+48 600 000 000' },
  URL:   { type: 'url', placeholder: 'https://...' },
  IBAN:  { type: 'text', placeholder: 'PL00 0000 0000 0000 0000 0000 0000' },
  NIP:   { type: 'text', inputMode: 'numeric', placeholder: '1234567890' },
  PESEL: { type: 'text', inputMode: 'numeric', placeholder: '00000000000' },
}

/**
 * Specjalizowany text input dla EMAIL / PHONE / URL / IBAN / NIP / PESEL.
 * Walidacja formatu uruchamia się on blur; komunikat błędu pod inputem aż user
 * go poprawi. Mapuje FieldType → natywny {@code type}/{@code inputMode}/placeholder.
 */
export function SpecializedTextInput({ field, value, onChange, disabled }: FieldInputProps) {
  const cfg = TYPE_MAP[field.fieldType] ?? { type: 'text' }
  const [touched, setTouched] = useState(false)
  const stringValue = value === null || value === undefined ? '' : String(value)
  const error = touched ? validateFieldFormat(field.fieldType, stringValue) : null

  return (
    <div className="flex flex-col gap-1">
      <input
        id={`field-${field.fieldCode}`}
        type={cfg.type}
        inputMode={cfg.inputMode}
        placeholder={cfg.placeholder}
        className={`${inputCommon(disabled)} ${error ? 'border-red-500' : ''}`}
        disabled={disabled}
        value={stringValue}
        onChange={e => onChange(e.target.value)}
        onBlur={() => setTouched(true)}
      />
      {error && <span className="text-xs text-red-600">{error}</span>}
    </div>
  )
}
